import { Component, Input, OnInit } from '@angular/core';

import { CartFunnelStoreDispatcher } from '@common/dispatchers/cart-funnel.dispatcher';
import { CartFunnelStoreSelector } from '@common/selectors/cart-funnel.selector';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
import { Observable, take, tap } from 'rxjs';

@Component({
  selector: 'app-kiosk-cart-funnel-pager-block',
  templateUrl: './kiosk-cart-funnel-pager-block.component.html',
})
export class KioskCartFunnelPagerBlockComponent implements OnInit {
  @Input() title!: string;
  @Input() value!: string;
  @Input() subtitle!: string;
  @Input() required = true;
  @Input() blockId!: string;
  @Input() formId!: string;
  @Input() color?: IContentBuilderFieldColor;
  @Input() pagerSize: number = 2;
  @Input() minPagerSize?: number;

  funnelUsername$: Observable<string | null> = this.cartFunnelSelector.selectfunnelUsername;

  constructor(
    private cartFunnelDispatcher: CartFunnelStoreDispatcher,
    private cartFunnelSelector: CartFunnelStoreSelector,
  ) {}

  ngOnInit(): void {
    this.cartFunnelSelector
      .selectValue(this.blockId)
      .pipe(
        take(1),
        tap(form => {
          // set initial value if not set
          if (!this.value) {
            this.value = form?.value as string;
          }
        }),
      )
      .subscribe(form => {
        if (form) {
          return;
        }
        // if form is not set, add it to the store values
        this.cartFunnelDispatcher.addValue({
          id: this.blockId,
          title: this.title,
          displayTitle: true,
          formId: this.formId,
          required: this.required,
        });
      });
  }

  onValueChange(_value: string | boolean): void {
    this.cartFunnelDispatcher.updateValue({
      id: this.blockId,
      changes: {
        value: _value,
      },
    });
  }
}
